import RoarPage from '../components/roar/landing-page'
export default RoarPage
